export const APPS = [
  { value: 'AR Drawing', fullName: 'AR Drawing: Sketch & Paint', variant: 'ar-drawing' },
  { value: 'Calano',     fullName: 'Calano',     variant: 'calano' },
  { value: 'Drawio',     fullName: 'Drawio',     variant: 'drawio' },
  { value: 'StyleMatch', fullName: 'StyleMatch', variant: 'stylematch' },
  { value: 'Dopafit',    fullName: 'Dopafit',    variant: 'dopafit' },
  // SCOPE-FB-ACCOUNTS F2 (owner ruling 1, 2026-09-14): the `VanDraw` sheet tab is its own
  // application, stamped onto every pack the sync builds from that tab.
  { value: 'VanDraw',    fullName: 'VanDraw',    variant: 'vandraw' },
  { value: 'VanGami',    fullName: 'VanGami',    variant: 'vangami' },
];

// Applications a contract can be written for (contracts.application; the first is the default).
export const CONTRACT_APPS = ['AR Drawing', 'VanDraw', 'VanGami'];

// The stored value is the short code (badges, filters); the full name is for places that name the app in full.
export function appFullName(code) {
  return APPS.find((a) => a.value === code)?.fullName ?? code ?? '';
}

export function appBadgeVariant(app) {
  const s = String(app || '').toLowerCase().trim();
  if (!s) return 'default';
  if (s.includes('ar drawing') || s.includes('ar_drawing')) return 'ar-drawing';
  if (s.includes('calano')) return 'calano';
  if (s.includes('drawio')) return 'drawio';
  if (s.includes('stylematch') || s.includes('style match')) return 'stylematch';
  if (s.includes('dopafit') || s.includes('dopa fit')) return 'dopafit';
  if (s.includes('vandraw') || s.includes('van draw')) return 'vandraw';
  if (s.includes('vangami') || s.includes('van gami')) return 'vangami';
  return 'default';
}

// INVOICE-APP — the pack's application as a badge (invoice card, «Новый инвойс», Инвойсы list):
// `.app-badge` in the appBadgeVariant colour; no application → «без приложения» on the neutral variant.
export function appBadge(app) {
  return { className: `app-badge app-badge--${appBadgeVariant(app)}`, label: app || 'без приложения' };
}
